let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("af6La")).then(() => parcelRequire('jos5m'));